import { Component } from '@mycolorway/tao';
import { MDCMenuSurfaceFoundation } from '@material/menu-surface';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import SelectorField from './selector-field';
import './combo-select-field/result';

export default Component('tr-combo-select-field', {
  extends: [SelectorField],

  mixins: [eventListenerMixin],

  properties: {
    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.nativeField.disabled = this.disabled;
      },
    },

    creation: {
      type: Object,
      default: null,
    },
  },

  ready() {
    this.helperText = this.querySelector('.mdc-select-helper-text');
    this.list.setAnchor(this.result.querySelector('.mdc-select'));

    this.bindResultEvents();
    this.bindListEvents();

    const that = this;
    // eslint-disable-next-line no-underscore-dangle
    this.list.mdcMenuSurface
      .foundation_.handleBodyClick = function handleBodyClick(event) {
        if (that.contains(event.target)) return;
        MDCMenuSurfaceFoundation.prototype.handleBodyClick.call(this, event);
      };
  },

  layout() {
    this.result.layout();
  },

  focus() {
    this.result.focus();
  },

  bindResultEvents() {
    this.listenTo(this.result, {
      'tr-combo-select-field-result:active': this.handleResultActive.bind(this),
      'tr-combo-select-field-result:deactive': this.handleResultDeactive.bind(this),
      'tr-combo-select-field-result:blur': this.handleResultBlur.bind(this),
      'tr-combo-select-field-result:search': this.handleSearch.bind(this),
      'tr-combo-select-field-result:arrowPress': this.handleResultArrowPress.bind(this),
      'tr-combo-select-field-result:enterPress': this.handleResultEnterPress.bind(this),
    });
  },

  bindListEvents() {
    this.listenTo(this.list, {
      'tr-selector-field-list:beforeOpen': () => {
        this.list.setAnchorMargin({ top: -this.helperText.offsetHeight });
      },
      'tr-selector-field-list:closed': this.handleListClosed.bind(this),
    });
  },

  handleResultActive() {
    if (!this.disabled && !this.readonly) this.toggleList(true);
  },

  handleResultDeactive() {
    if (this.list.isOpen()) this.toggleList(false);
  },

  handleResultBlur(event) {
    const { relatedTarget } = event.detail.originalEvent;
    if (relatedTarget && this.list.elementInContainer(relatedTarget)) return;

    this.result.active = false;
  },

  handleSearch(event) {
    this.toggleList(true);
    this.filterList(event.detail, () => this.list.highlightFirstItem());
  },

  handleResultArrowPress(event) {
    if (!this.list.isOpen()) {
      this.toggleList(true);
    } else if (event.detail === 'up') {
      this.list.highlightPrevItem();
    } else {
      this.list.highlightNextItem();
    }
  },

  handleResultEnterPress(event) {
    const { originalEvent } = event.detail;
    if (this.list.isOpen()) {
      originalEvent.stopPropagation();
      originalEvent.preventDefault();
    }

    const { value } = this.list.highlightedItem ? this.list.highlightedItem.dataset : {};
    if (value === 'creation-message') {
      this.createItem(originalEvent.target.value);
      originalEvent.target.value = '';
    } else if (value) {
      const option = this.list.options.find(item => item.value === value);
      if (option) {
        const selected = this.selectOption(option);

        if (selected) {
          this.toggleList(this.multiple);
        } else {
          this.unselectOption(option);
          this.toggleList(true);
        }

        this.notifyChange();
      }
    }
  },

  handleListClosed() {
    this.result.active = false;
    this.namespacedTrigger('menuClosed', { bubbles: true });
  },

  createItem(value) {
    if (!value) return;
    this.dataProvider.create(value, (option, options) => {
      this.list.setOptions(options);
      this.selectOption(option);
      this.notifyChange();
    });
  },

  reset() {
    this.clearSelected();
  },
});
